<template>
  <div style="max-width:1200px;margin:0 auto;">
    <el-menu
      :default-active="activePath"
      mode="horizontal"
      router
    >
      <el-menu-item index="/"><img width="16" style="filter:brightness(0.2);margin-right:8px;" src="/favicon.ico" /> {{ config.url || "001210.com"}}</el-menu-item>
      <el-sub-menu index="/code">
        <template #title>编程语言</template>
        <el-menu-item v-for="(tab, index) in tabs" :index="'/code/' + tab.type" :key="index">{{tab.label}}</el-menu-item>
      </el-sub-menu>
      <el-menu-item index="/about">关于</el-menu-item>
    </el-menu>
  </div>
  <el-backtop :right="30" :bottom="30" />
</template>

<script setup name="NavView">
import { useStore } from "vuex";
import { onMounted, shallowRef } from 'vue'
const store = useStore()
const activePath = shallowRef("")
const {config, tabs} = store.state
onMounted(() => {
  activePath.value = location.pathname
})
</script>